// src/components/LabelPrintModal.js
import React, { useEffect, useState } from 'react';
import QRCode from 'qrcode';
import { qrMaxLabelHtml, qrSvgFor } from '../labels/qrMaxLabel';

export default function LabelPrintModal({ item, onClose, autoMode = false }) {
  const [qrDataUrl, setQrDataUrl] = useState('');

  const scanUrl = `${window.location.origin}/scan/${item.qr_code_id}`;

  useEffect(() => {
    QRCode.toDataURL(scanUrl, { width: 400, margin: 1, errorCorrectionLevel: 'M' })
      .then(url => setQrDataUrl(url))
      .catch(console.error);
  }, [scanUrl]);

  const handlePrint = () => {
    const assetTag = item.asset_tag || '';
    const toolName = (item.name || '').substring(0, 60);
    const qrSvg    = qrSvgFor(scanUrl);   // the printed label uses a crisp SVG

    const win = window.open('', '_blank', 'width=420,height=520,toolbar=0,location=0,menubar=0,scrollbars=0,resizable=1');
    if (!win) {
      alert('Popups are blocked. Please allow popups for this site to print labels.');
      return;
    }

    win.document.write(qrMaxLabelHtml({ assetTag, toolName, qrSvg }));
    win.document.close();
    win.focus();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-sheet">
        <div className="modal-handle" />
        <h3 style={{ marginBottom: 4 }}>Print Asset Label</h3>
        <p style={{ fontSize: '0.82rem', color: 'var(--text-muted)', marginBottom: 20 }}>
          {autoMode
            ? 'Item saved! Print a label now, or skip and print later from the Edit screen.'
            : 'Opens a print preview with setup instructions.'}
        </p>

        {/* Label preview: three lines sideways on the left, QR on the right */}
        <div style={{
          border: '1px dashed var(--border)',
          borderRadius: 8,
          padding: 10,
          marginBottom: 20,
          background: '#fafafa',
          display: 'flex',
          justifyContent: 'center',
          minHeight: 120
        }}>
          {qrDataUrl ? (
            <div style={{ width: 150, height: 120, background: '#fff', display: 'flex', alignItems: 'center',
                          padding: '10px 8px', gap: 4, boxShadow: '0 0 0 1px #e5e7eb' }}>
              <div style={{ width: 29, height: 100, display: 'flex', flexDirection: 'column', justifyContent: 'center',
                            alignItems: 'center', writingMode: 'vertical-rl', transform: 'rotate(180deg)',
                            overflow: 'hidden', color: '#000', lineHeight: 1, whiteSpace: 'nowrap' }}>
                <span style={{ fontSize: 6, fontWeight: 700, letterSpacing: 0.4 }}>NEXT GEN CONST</span>
                <span style={{ fontSize: item.asset_tag && item.asset_tag.length > 12 ? 10 : 11, fontWeight: 900 }}>
                  {item.asset_tag || '—'}
                </span>
                <span style={{ fontSize: 6, maxHeight: '100%', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {item.name}
                </span>
              </div>
              <img src={qrDataUrl} alt="QR Code" style={{ width: 101, height: 101, display: 'block' }} />
            </div>
          ) : (
            <p style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>Generating QR code...</p>
          )}
        </div>

        <button className="btn btn-primary" onClick={handlePrint} disabled={!qrDataUrl}
          style={{ marginBottom: 10 }}>
          Open Print Preview
        </button>
        <button className="btn btn-ghost" onClick={onClose}>
          {autoMode ? 'Skip — Print Later' : 'Close'}
        </button>
      </div>
    </div>
  );
}
